import { Divider, Table, Spin, Tooltip, Row, Col, Modal, Button } from 'antd'
import { useEffect, useState } from 'react'
import { getUserDevices, deleteUserDevice } from 'src/api/user'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { isoToTimestamp } from 'src/utils/timestamp'
import UserSearch from 'src/components/Search/UserSearch'
import { DeleteOutlined } from '@ant-design/icons'
const LoggedInUsers = () => {
  const [loading, setLoading] = useState(true)
  const [username, setUsername] = useState(undefined)
  const [transformedData, setTransformedData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [totalRecords, setTotalRecords] = useState(0)

  const transformData = async (data) => {
    if (data == null) {
      return null
    }

    return await Promise.all(
      data.map(async (item) => {
        return {
          ...item,
          username: item.username,
          imei: item.imei,
          date: isoToTimestamp(item.loginTime),
        }
      })
    )
  }

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination
    setCurrentPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  const handleDelete = async (item) => {
    setLoading(true)
    await deleteUserDevice(item)
    await fetchDeviceData(currentPage, pageSize, username, true)
    setUsername('')
    setLoading(false)
  }

  const fetchDeviceData = async (page, size, userId, isAfterDelete = false) => {
    try {
      setLoading(true)
      const response = await getUserDevices(page - 1, size, userId)
      const transformedData = await transformData(response.data)
      const total = response.total_items

      if (isAfterDelete && transformedData.length === 0 && page > 1) {
        setCurrentPage((prev) => prev - 1)
        await fetchDeviceData(page - 1, size, userId)
        return
      }

      setTransformedData(transformedData)
      setTotalRecords(total)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchDeviceData(currentPage, pageSize, username || '')
  }, [pageSize, currentPage, username])

  const columns = [
    {
      title: 'User Name',
      dataIndex: 'username',
      key: 'username',
      width: 250,
    },
    {
      title: 'IMEI',
      dataIndex: 'imei',
      key: 'imei',
      width: 400,
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      width: 250,
    },
    {
      title: 'Delete',
      key: 'delete',
      render: (_, record) => (
        <Button type="primary" danger onClick={() => handleDelete(record)}>
          <DeleteOutlined />
        </Button>
      ),
    },
  ]

  return (
    <>
      <Spin spinning={loading}>
        <UserSearch
          placeholder="Search Username"
          value={username}
          onChange={(value) => {
            setUsername(value)
            setCurrentPage(1)
            setPageSize(10)
            fetchDeviceData(1, 10, value)
          }}
        />

        <Divider />
        <DndProvider backend={HTML5Backend}>
          <Table
            dataSource={transformedData}
            columns={columns}
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              showSizeChanger: true,
              pageSizeOptions: ['10', '25', '50', '100'],
              total: totalRecords,
            }}
            onChange={handleTableChange}
          />
        </DndProvider>
      </Spin>
    </>
  )
}

export default LoggedInUsers
